import { render, staticRenderFns } from "./PortalGroup.vue?vue&type=template&id=12303894&"
import script from "./PortalGroup.vue?vue&type=script&lang=js&"
export * from "./PortalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../ceesar.scenario.ranking/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports